import type React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { AuthToken } from '@cobliteam/api-lib/src/account/session/AuthToken';

import type { AppState } from '@cobliteam/store/src/AppState';
import { sessionRequest } from '@cobliteam/store/src/Login/actionCreators';
import { loadUserAttributesSucceeded } from '@cobliteam/store/src/Users/actionCreators';

import useUser from '@cobliteam/hooks/src/useEntity/useUser';

import LoadingPage from '../pages/LoadingPage';

interface PrivateRouterProviderProps {
  children: React.ReactNode;
}

const PrivateRouterProvider = ({ children }: PrivateRouterProviderProps) => {
  const dispatch = useDispatch();
  const session = useSelector((state: AppState) => state.login.session);
  const authToken = localStorage.getItem(AuthToken.ACCESS_TOKEN);

  const { useGetUserData } = useUser();
  const { data: user } = useGetUserData(session?.user.id, !!session);

  // get session
  useEffect(() => {
    if (authToken && !session) dispatch(sessionRequest());
  }, [authToken, dispatch, session]);

  // update attributes
  useEffect(() => {
    if (user?.userAttributes)
      dispatch(loadUserAttributesSucceeded(user?.userAttributes));
  }, [dispatch, session, user]);

  if (!authToken) return <Redirect to='/login' />;

  if (authToken && session && user) return children;

  return <LoadingPage message='Carregando suas preferências e dados...' />;
};

export default PrivateRouterProvider;
